import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaStar, FaRegStar } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';


export function ApartmentModal ({ setShowApartmentModal, getData, pageData }) {
  const {userProfile, logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({});
  const [formPlans, setFormPlans] = useState({});
  const [plans, setPlans] = useState([
    { title: "", benefits: "", amount: "" }
  ]);
  const [beds, setBeds] = useState([
    { bed_type: "", quantity: "" }
  ]);
  const [amenities, setAmenities] = useState([
    { name: "" }
  ]);
  const [apartments, setApartments] = useState([
    { apt_name: "" }
  ]);

  const [images, setImages] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files); // FileList → Array
    setImages(files);
  };

  const addRow = (type) => {
    if (type == "beds") {
        setBeds([
        ...beds,
        { bed_type: "", quantity: "" }
        ]);
    } else if (type == "amenities") {
        setAmenities([
        ...amenities,
        { name: "" }
        ]);
    } else if (type == "apartments") {
        setApartments([
        ...apartments,
        { apt_name: "", apt_code: "" }
        ]);
    } else {
        setPlans([
        ...plans,
        { title: "", benefits: "", amount: "" }
        ]);
    }
  };

  const removeRow = (index, type) => {
    if (type == "beds") {
        setBeds(beds.filter((_, i) => i !== index));
    } else if (type == "amenities") {
        setAmenities(amenities.filter((_, i) => i !== index));
    } else if (type == "apartments") {
        setApartments(apartments.filter((_, i) => i !== index));
    } else {
        setPlans(plans.filter((_, i) => i !== index));
    }
  };

  const handleChange = (index, field, value, type) => {
    if (type == "beds") {
        const updated = [...beds];
        updated[index][field] = value;
        setBeds(updated);
    } else if (type == "amenities") {
        const updated = [...amenities];
        updated[index][field] = value;
        setAmenities(updated);
    } else if (type == "apartments") {
        const updated = [...apartments];
        updated[index][field] = value;
        setApartments(updated);
    } else {
        const updated = [...plans];
        updated[index][field] = value;
        setPlans(updated);
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    formData.append('pricing_plans', JSON.stringify(plans));
    formData.append('beds', JSON.stringify(beds));
    formData.append('amenities', JSON.stringify(amenities));
    formData.append('apartments', JSON.stringify(apartments));
    images.forEach((image, index) => {
      formData.append(`images[]`, image);
    });

    setLoading(true)
    try {
        const response = await axios.post(base_url + '/create-apartment.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                accountid: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.message
            })
            getData();
            setShowApartmentModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.message
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] max-h-[80%] overflow-y-auto w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowApartmentModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[15px] font-bold'>Create New Apartments</a>
                 <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, branch_id: e.target.value})}
                  >
                    <option value="">Choose branch</option>
                    {pageData?.branches?.map((item, index) => 
                        <option key={index} value={item.branch_id}>{item.branch_name}</option>
                    )}
                  </select>
                  <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, category: e.target.value})}
                  >
                    <option value="">Choose category</option>
                    <option value="Single Room">Single Room</option>
                    <option value="Standard">Standard</option>
                    <option value="Deluxe">Deluxe</option>
                    <option value="Superior Deluxe">Superior Deluxe</option>
                    <option value="Deluxe Suite">Deluxe Suite</option>
                    <option value="Prestige Penthouse">Prestige Penthouse</option>
                  </select>
                  {/* <input type='default' onChange={(e) => setFormFields({...formFields, apartment_code: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Apartment Code" /> */}
                  {/* <input type='default' onChange={(e) => setFormFields({...formFields, apartment_name: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Apartment Name" /> */}
                  {/* <input type='default' onChange={(e) => setFormFields({...formFields, apartment_count: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="No. of Apartment" /> */}

                  <div className='w-[80%] mx-auto'>
                    <label className='text-md font-bold my-2'>Apartments</label>
                    {apartments.map((item, index) => (
                        <div
                        key={index}
                        className="my-1 grid grid-cols-1 gap-3 border p-4 rounded-lg"
                        >
                        <input
                            type="text"
                            placeholder="Apartment Name"
                            value={item.apt_name}
                            onChange={(e) =>
                            handleChange(index, "apt_name", e.target.value, 'apartments')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <input
                            type="text"
                            placeholder="Apartment Code"
                            value={item.apt_code}
                            onChange={(e) =>
                            handleChange(index, "apt_code", e.target.value, 'apartments')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <button
                            type="button"
                            onClick={() => removeRow(index, 'apartments')}
                            disabled={apartments.length === 1}
                            className="bg-red-500 text-white rounded px-3 py-2 disabled:opacity-40"
                        >
                            Remove
                        </button>
                        </div>
                    ))}

                    <div className="flex gap-3 my-2">
                        <button
                        type="button"
                        onClick={() => addRow('apartments')}
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                        + Add Apartment
                        </button>
                    </div>
                  </div>

                  <input type='number' onChange={(e) => setFormFields({...formFields, bedrooms: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="No. of Bedrooms" />
                  <input type='number' onChange={(e) => setFormFields({...formFields, guest_count: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="How many guests?" />
                  <input type='number' onChange={(e) => setFormFields({...formFields, refundable_deposit: e.target.value})} className="w-[80%] mx-auto border p-2 rounded my-2" placeholder="Refundable Deposit" />
                  <div className='w-[80%] mx-auto'>
                    <label className='text-md font-bold my-2'>Pricing Plans</label>
                    {plans.map((item, index) => (
                        <div
                        key={index}
                        className="my-1 grid grid-cols-1 gap-3 border p-4 rounded-lg"
                        >
                        <input
                            type="text"
                            placeholder="Title"
                            value={item.title}
                            onChange={(e) =>
                            handleChange(index, "title", e.target.value, 'plans')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <input
                            type="text"
                            placeholder="Benefits"
                            value={item.benefits}
                            onChange={(e) =>
                            handleChange(index, "benefits", e.target.value, 'plans')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <input
                            type="number"
                            placeholder="Amount"
                            value={item.amount}
                            onChange={(e) =>
                            handleChange(index, "amount", e.target.value, 'plans')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <button
                            type="button"
                            onClick={() => removeRow(index, 'plans')}
                            disabled={plans.length === 1}
                            className="bg-red-500 text-white rounded px-3 py-2 disabled:opacity-40"
                        >
                            Remove
                        </button>
                        </div>
                    ))}

                    <div className="flex gap-3 my-2">
                        <button
                        type="button"
                        onClick={() => addRow('plans')}
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                        + Add Plan
                        </button>
                    </div>
                  </div>
                  <select
                    className="w-[80%] mx-auto border p-2 rounded my-2"
                    // value={formFields?.apt_id}
                    onChange={(e) => setFormFields({...formFields, currency: e.target.value})}
                  >
                    <option value="">Choose currency</option>
                    <option value="NGN">NGN</option>
                  </select>
                  <div className='w-[80%] mx-auto'>
                    <label className='text-md font-bold my-2'>Beds</label>
                    {beds.map((item, index) => (
                        <div
                        key={index}
                        className="my-1 grid grid-cols-1 gap-3 border p-4 rounded-lg"
                        >
                        <input
                            type="text"
                            placeholder="Bed Type"
                            value={item.bed_type}
                            onChange={(e) =>
                            handleChange(index, "bed_type", e.target.value, 'beds')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <input
                            type="number"
                            placeholder="Quantity"
                            value={item.quantity}
                            onChange={(e) =>
                            handleChange(index, "quantity", e.target.value, 'beds')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <button
                            type="button"
                            onClick={() => removeRow(index, 'beds')}
                            disabled={beds.length === 1}
                            className="bg-red-500 text-white rounded px-3 py-2 disabled:opacity-40"
                        >
                            Remove
                        </button>
                        </div>
                    ))}

                    <div className="flex gap-3 my-2">
                        <button
                        type="button"
                        onClick={() => addRow('beds')}
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                        + Add Bed
                        </button>
                    </div>
                  </div>
                  <div className='w-[80%] mx-auto'>
                    <label className='text-md font-bold my-2'>Amenities</label>
                    {amenities.map((item, index) => (
                        <div
                        key={index}
                        className="my-1 grid grid-cols-1 gap-3 border p-4 rounded-lg"
                        >
                        <input
                            type="text"
                            placeholder="Item"
                            value={item.name}
                            onChange={(e) =>
                            handleChange(index, "name", e.target.value, 'amenities')
                            }
                            className="border rounded px-3 py-2"
                        />

                        <button
                            type="button"
                            onClick={() => removeRow(index, 'amenities')}
                            disabled={amenities.length === 1}
                            className="bg-red-500 text-white rounded px-3 py-2 disabled:opacity-40"
                        >
                            Remove
                        </button>
                        </div>
                    ))}

                    <div className="flex gap-3 my-2">
                        <button
                        type="button"
                        onClick={() => addRow('amenities')}
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                        + Add Item
                        </button>
                    </div>
                  </div>
                  <textarea
                    className="my-4 w-[80%] mx-auto border border-gray-300 rounded-lg p-3 min-h-[100px] outline-none focus:border-blue-500"
                    placeholder={`Description`}
                    value={formFields?.description}
                    onChange={(e) => setFormFields({...formFields, description: e.target.value})}
                  />
                  <label>
                        Select Images:
                  </label>
                  <input
                        type="file"
                        className="w-[80%] mx-auto border p-2 rounded my-2"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                    />
                  <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Add Apartment
                        </button>
                    </div>
                {loading ? (
                    <ClockLoader
                        color={'#212121'}
                        loading={loading}
                        size={25}
                        className='mt-3'
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    ) : null
                }
            </div>  
        </div>
    )
}

